/* 🤖 this file was generated by svg-to-ts */
export const siriusPlus: {
  name: 'plus';
  data: string;
} = {
  name: 'plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M12.75 3.75a.75.75 0 0 0-1.5 0v7.5h-7.5a.75.75 0 0 0 0 1.5h7.5v7.5a.75.75 0 0 0 1.5 0v-7.5h7.5a.75.75 0 0 0 0-1.5h-7.5v-7.5Z" fill="currentColor"/></svg>`
};
